<div class="office-management-header">
    <h2>Liste des cabinets</h2>
    <div class="search-add">
        <div class="search-bar-container">
            <frg-search-input (search)="onSearch($event)"></frg-search-input>
        </div>
        <button routerLink="/administration/office-creation/create">
            <div class="svg-office-add"></div>
        </button>
    </div>
</div>
<div class="office-management-body">
    <div class="office-management-table">
        <div class="table">
            <frg-table [keysBody]="officeList" [keysColumn]="officeColumnTable" tableButton1="assets/icons/trash.svg"
                tableButton2="assets/icons/edit.svg" (onClick1)="deleteOffice($event)" (onClick2)="editOffice($event)"
                (onChangePage)="onChangePage($event)" (onSort)="onSort($event)">
            </frg-table>
        </div>
    </div>
</div>